module.exports = __webpack_public_path__ + "fonts/poppins-light-webfont.cfb91825.woff";